import { states } from './states'

const getStateOptions = () => {
  return states.map((state) => ({
    value: state.abbreviation,
    label: state.name,
  }))
}

export const STATE_OPTIONS = getStateOptions()
